import { Box } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import DeleteBtn from "src/components/shared/DeleteBtn";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import UpdateBtn from "src/components/shared/UpdateBtn";
import ViewBtn from "src/components/shared/ViewBtn";
import { orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useBulkReturnProcessingList from "src/hooks/orders/bulk-return-processing/useBulkReturnProcessingList";
import { ProductStateTranslation } from "src/utils/productState";
import { v4 as uuid } from "uuid";
import BulkReturnProcessingDialog from "../../bulk-return-processing/dialog/BulkReturnProcessingDialog";
import BulkReturnDetail from "../../bulk-return-processing/dialog/BulkReturnDetail";
import useRemoveBulkReturnDetail from "src/hooks/orders/bulk-return-processing/useRemoveBulkReturnDetail";
import { enqueueSnackbar } from "notistack";

const productType = {
  LostCode: "Pending",
  Normal: "confirm",
  Damaged: "reject",
};

const FORM_STATUS = {
  Draft: "Nháp",
  Done: "Hoàn thành",
};

const headers = [
  {
    id: uuid(),
    title: "STT",
    width: "20px",
    align: "center",
  },
  {
    id: uuid(),
    title: "Ngày trả hàng",
    align: "center",
  },
  {
    id: uuid(),
    title: "Kho nhập trả",
    align: "center",
  },
  {
    id: uuid(),
    title: "Trạng thái đơn",
    align: "center",
  },
  {
    id: uuid(),
    title: "Tình trạng hàng trả",
    align: "center",
  },
  {
    id: uuid(),
    title: "SL sản phẩm",
    align: "center",
  },
  {
    id: uuid(),
    title: "NV xử lý",
    align: "center",
  },
  {
    id: uuid(),
    title: "Thao tác",
    align: "center",
  },
];
export default function useBulkReturnProcessing(warehouseId, type) {
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const { trigger: deleteForm } = useRemoveBulkReturnDetail();

  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });

  const { data } = useBulkReturnProcessingList({
    ...pagi,
    sortOrder: "asc",
    type: type,
    warehouse: warehouseId,
  });

  const handleView = (item) => {
    handleOpenDialog({
      title: "Chi tiết",
      content: <BulkReturnDetail item={item} />,
      size: "md",
    });
  };

  const handleUpate = (item) => {
    return handleOpenDialog({
      size: "lg",
      content: (
        <BulkReturnProcessingDialog
          returnedFormId={item?._id}
          warehouseId={item?.warehouse?._id}
        />
      ),
    });
  };

  const handleDelete = async (item) => {
    const res = await deleteForm({
      pathIncluded: {
        id: item?._id,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const bodyList = Array.isArray(data?.data)
    ? data?.data?.map((v, i) => ({
        ...v,
        no: i + 1 + pagi?.skip,
        warehouse: v?.warehouse?.name,
        status: (
          <ProcessingBadge
            value={FORM_STATUS[v?.status]}
            asset={{ color: orderStatusFormatted[v?.status], text: orderStatusFormatted[v?.status] }}
          />
        ),
        type: (
          <ProcessingBadge
            value={ProductStateTranslation[v?.type]}
            asset={{ color: productType[v?.type], text: productType[v?.type] }}
          />
        ),
        returnedDay: dayjs(v?.createdAt).format("DD/MM/YYYY"),
        qty: v?.totalQty ?? 0,
        staff: v?.createdBy?.fullName,
        action: (
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <ViewBtn handleView={() => handleView(v)} />
            <UpdateBtn
              disabled={v?.status === orderStatusFormatted.Done}
              handleUpdate={() => handleUpate(v)}
            />

            <DeleteBtn
              disabled={v?.status === orderStatusFormatted.Done}
              handleDelete={() => handleDelete(v)}
            />
          </Box>
        ),
      }))
    : [];

  const sortData = ["no", "returnedDay", "warehouse", "status", "type", "qty", "staff", "action"];

  return { headers, bodyList, sortData, setPagi, pagi };
}
